/**
 * 图片加载失败时，显示默认图片
 * @param {String} defaultImg 默认图片
 * @param {String} type 图片类型
 * @example
 * <img v-real-img="imgUrl" defaultImg="默认图片" />
 */

const realImg = {
  async beforeMount(el, { value }) {
    const defaultImg = el.getAttribute('defaultImg'); // 获取defaultImg属性值
    if (value) {
      const exist = await imageIsExist(value);
      el.setAttribute('src', exist ? value : defaultImg);
    }
    // 判断一个图片是否存在, 注意是异步行为
    function imageIsExist(url) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = url;
        img.onload = () => {
          if (img.complete) {
            resolve(true);
            img = null;
          }
        };
        img.onerror = () => {
          resolve(false);
          img = null;
        };
      });
    }
  }
};

export default realImg;
